import * as React from 'react';
import { useEffect } from 'react';
import { BeKindSection } from '../../components/block-be-kind';
import { Footer } from '../../components/footer';
import { InstagramFeed } from '../../components/homepageComponents';
import { Layout } from '../../components/layout';
import { Seo } from '../../components/seo';
import { styled } from '../../styles/stitches.config';

const FAQ = () => {
    useEffect(() => {
        document.getElementsByTagName('body')[0].style.overflow = "auto";
    }, []);
    const ContentContainer = styled('section', {
        padding: '80px 0 80px 0',
        maxWidth: '780px',
        margin: '0 auto',
        '@bp1': {
            paddingLeft: '20px',
            paddingRight: '20px',
        },
        h1: {
            fontFamily: '$default',
            textAlign: 'center',
            fontSize: '36px',
            marginBottom: '56px',
        },
        h2: {
            fontFamily: '$lato',
            fontSize: '18px',
            letterSpacing: '0.1em',
            margin: '0 0 24px 0',
        },
        p: {
            fontFamily: '$lato',
            color: '#585d6c',
            margin: '0 0 24px 0',
            fontSize: '18px',
            lineHeight: '29px',
        }
    });

    return (
        <Layout>
            <Seo
                title={'Frequently Asked Questions - Better Days Skin Co.'}
            />
            <ContentContainer>
                <h1>Frequently Asked Questions</h1>
                <h2>DO YOU TEST ON ANIMALS?</h2>
                <p>No, we never test on animals.</p>
                <h2>IS IT FRAGRANCE FREE?</h2>
                <p>Yes. We do not formulate with any added fragrance or fragrant essential oils. If there is any smell, it is simply the smell of the raw ingredients in the formula. We like to call it &quot;the smell of science&quot;, our users have described it to be a pleasant oatmeal smell.</p>
                <h2>IS IT SUITABLE FOR PEOPLE WITH SENSITIVE SKIN?</h2>
                <p>While it is formulated with sensitive skin conditions in mind, and we&apos;ve had no issues based on our feedback from testers, everyone&apos;s skin is different and reacts to products differently. We recommend that you always patch test and wait 24 hours before using any product.</p>
                <h2>IS IT NON-COMEDOGENIC?</h2>
                <p>We avoid all high rating comedogenic ingredients. Our ingredient list can be found here, should you like to read more about them.</p>
                <h2>WHAT IS THE EXPIRY DATE/SHELF LIFE?</h2>
                <p>Please refer to the PAO (Period After Opening) symbols labelled on the back of the bottle and the packaging.</p>
                <h2>HOW LONG WILL IT TAKE TO SEE RESULTS?</h2>
                <p>You will see some immediate brightening and softening effects but generally speaking, a skin cycle takes between 4-8 weeks. The full benefits of the product will be visible after a full skin cycle. It should be noted that healthy skin naturally requires a complementing lifestyle that may include healthy diet, exercise, quality sleep etc.</p>
                <h2>CAN I USE THE MULTI-ACTIVE TREATMENT ESSENCE IF I AM BREASTFEEDING OR PREGNANT?</h2>
                <p>As the product contains Salicylic Acid (BHA), we recommend that you check with your doctor before using this product to ensure your safety. Our BHA is formulated at 1.5%.</p>
                <h2>WHAT DOES PRE-ORDERING MEAN?</h2>
                <p>A pre-order means that you can place an order of an item that will be made available for shipping at a later date. The estimated shipment date will be displayed on the product page. Once your order is placed, we will reserve the item and deliver it to you as soon as it is ready. We will follow this up with a notification email once it is shipped out.</p>
                <h2>WHERE CAN I PURCHASE BETTER DAYS SKIN CO. PRODUCTS?</h2>
                <p>We sell exclusively on our own website www.bedaskin.com and do not have plans for physical retail stores. If you would like to be notified of any pop-ups or promotions, please sign up to our mailing list here.</p>
                <h2>WHERE IS THE PRODUCT MADE?</h2>
                <p>We are formulated and made in Singapore.</p>
            </ContentContainer>
            <BeKindSection />
            <InstagramFeed />
        </Layout>
    )
}

export default FAQ;
